import { sva } from "styled-system/css";

export const eventMessageCardRecipe = sva({
  slots: ["container", "text"],
  base: {
    container: {
      bg: "bg.accent.blue.lightest",
      borderColor: "border.accent.blue",
      borderWidth: "2px",
      borderStyle: "solid",
      borderRadius: "150",
      px: "400",
      py: "300",
      h: "160px",
      minW: "360px",
    },
    text: {
      color: "text.accent.blue.dark",
    },
  },
  variants: {
    size: {
      mobile: {
        container: {
          h: "360px",
          w: "280px",
          minW: "280px",
        },
      },
      tablet: {},
      desktop: {},
      large: {},
    },
  },
  defaultVariants: {
    size: "mobile",
  },
});
